import type { FaireProductEntity } from "../../entity_types/product";

export const p_3as6aac63k: FaireProductEntity = {
  token: "p_3as6aac63k",
  type: "product",
  name: "Delicate Style Beautiful Knot Band Ring",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/9aae241b2ce9e441773118cb54e74bc39be13f5d8a642d57aa331074133b93ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6f7151d68ca55aed86d8a85500f9053f9df77ad0ca9002dbed3cdfcd91eb5397.jpeg"
  ],
  priceDollars: 7.5,
  description: "This beautiful knot ring is delicate in style, but impactful in its design. Wear it solo or stacked alongside your other favs.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:16.641Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
